// Comprehensive tile database with various categories
export const tilesData = [
  // CERAMIC TILES
  {
    id: 'ceramic-1',
    name: 'Classic White Ceramic',
    category: 'ceramic',
    description: 'Clean white ceramic tile perfect for any room',
    price: 45,
    priceUnit: 'per sq ft',
    size: '12" x 12"',
    dimensions: '12" x 12"',
    finish: 'Glossy',
    imageUrl: 'https://images.unsplash.com/photo-1615873968403-89e068629265?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1615873968403-89e068629265?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'ceramic-2',
    name: 'Beige Ceramic Tile',
    category: 'ceramic',
    description: 'Warm beige ceramic with subtle texture',
    price: 42,
    priceUnit: 'per sq ft',
    size: '12" x 24"',
    dimensions: '12" x 24"',
    finish: 'Matte',
    imageUrl: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'ceramic-3',
    name: 'Blue Mosaic Ceramic',
    category: 'ceramic',
    description: 'Beautiful blue ceramic mosaic pattern',
    price: 55,
    priceUnit: 'per sq ft',
    size: '12" x 12"',
    dimensions: '12" x 12"',
    finish: 'Glossy',
    imageUrl: 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'ceramic-4',
    name: 'Gray Ceramic Subway',
    category: 'ceramic',
    description: 'Modern gray subway tile for contemporary spaces',
    price: 48,
    priceUnit: 'per sq ft',
    size: '3" x 6"',
    dimensions: '3" x 6"',
    finish: 'Satin',
    imageUrl: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&h=800&fit=crop',
    featured: true
  },

  // MARBLE TILES
  {
    id: 'marble-1',
    name: 'Carrara White Marble',
    category: 'marble',
    description: 'Elegant Italian Carrara marble with gray veining',
    price: 125,
    priceUnit: 'per sq ft',
    size: '12" x 24"',
    dimensions: '12" x 24"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1615529182904-14819c35db37?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1615529182904-14819c35db37?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'marble-2',
    name: 'Black Marble Luxury',
    category: 'marble',
    description: 'Luxurious black marble with gold veining',
    price: 145,
    priceUnit: 'per sq ft',
    size: '24" x 24"',
    dimensions: '24" x 24"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1598905110628-e66a4e9372b1?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1598905110628-e66a4e9372b1?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'marble-3',
    name: 'Calacatta Gold Marble',
    category: 'marble',
    description: 'Premium Calacatta marble with gold veins',
    price: 165,
    priceUnit: 'per sq ft',
    size: '24" x 24"',
    dimensions: '24" x 24"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'marble-4',
    name: 'Emperador Brown Marble',
    category: 'marble',
    description: 'Rich brown marble with natural patterns',
    price: 135,
    priceUnit: 'per sq ft',
    size: '18" x 18"',
    dimensions: '18" x 18"',
    finish: 'Honed',
    imageUrl: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=800&h=800&fit=crop',
    featured: false
  },

  // WOOD-LOOK TILES
  {
    id: 'wood-1',
    name: 'Oak Wood Plank',
    category: 'wood-look',
    description: 'Realistic oak wood appearance with tile durability',
    price: 65,
    priceUnit: 'per sq ft',
    size: '6" x 36"',
    dimensions: '6" x 36"',
    finish: 'Matte',
    imageUrl: 'https://images.unsplash.com/photo-1615876234886-fd9a39fda97f?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1615876234886-fd9a39fda97f?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'wood-2',
    name: 'Walnut Wood Tile',
    category: 'wood-look',
    description: 'Dark walnut finish with natural grain patterns',
    price: 72,
    priceUnit: 'per sq ft',
    size: '6" x 48"',
    dimensions: '6" x 48"',
    finish: 'Textured',
    imageUrl: 'https://images.unsplash.com/photo-1544076200-c7c98c6c1f56?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1544076200-c7c98c6c1f56?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'wood-3',
    name: 'Ash Wood Effect',
    category: 'wood-look',
    description: 'Light ash wood design for modern spaces',
    price: 68,
    priceUnit: 'per sq ft',
    size: '8" x 48"',
    dimensions: '8" x 48"',
    finish: 'Matte',
    imageUrl: 'https://images.unsplash.com/photo-1544076200-ef1f3169c1e6?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1544076200-ef1f3169c1e6?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'wood-4',
    name: 'Reclaimed Barn Wood',
    category: 'wood-look',
    description: 'Rustic reclaimed wood appearance',
    price: 75,
    priceUnit: 'per sq ft',
    size: '6" x 36"',
    dimensions: '6" x 36"',
    finish: 'Textured',
    imageUrl: 'https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=800&h=800&fit=crop',
    featured: true
  },

  // PORCELAIN TILES
  {
    id: 'porcelain-1',
    name: 'Concrete Look Porcelain',
    category: 'porcelain',
    description: 'Industrial concrete aesthetic in durable porcelain',
    price: 58,
    priceUnit: 'per sq ft',
    size: '24" x 24"',
    dimensions: '24" x 24"',
    finish: 'Matte',
    imageUrl: 'https://images.unsplash.com/photo-1604428358884-a653e661c0f9?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1604428358884-a653e661c0f9?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'porcelain-2',
    name: 'Large Format Gray Porcelain',
    category: 'porcelain',
    description: 'Sleek gray porcelain for modern interiors',
    price: 62,
    priceUnit: 'per sq ft',
    size: '24" x 48"',
    dimensions: '24" x 48"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'porcelain-3',
    name: 'Terrazzo Porcelain',
    category: 'porcelain',
    description: 'Trendy terrazzo pattern in porcelain',
    price: 70,
    priceUnit: 'per sq ft',
    size: '12" x 12"',
    dimensions: '12" x 12"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'porcelain-4',
    name: 'Ivory Porcelain',
    category: 'porcelain',
    description: 'Elegant ivory porcelain with subtle texture',
    price: 55,
    priceUnit: 'per sq ft',
    size: '12" x 24"',
    dimensions: '12" x 24"',
    finish: 'Satin',
    imageUrl: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800&h=800&fit=crop',
    featured: false
  },

  // GRANITE TILES
  {
    id: 'granite-1',
    name: 'Black Galaxy Granite',
    category: 'granite',
    description: 'Deep black granite with gold speckles',
    price: 95,
    priceUnit: 'per sq ft',
    size: '12" x 12"',
    dimensions: '12" x 12"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'granite-2',
    name: 'Kashmir White Granite',
    category: 'granite',
    description: 'White granite with gray and burgundy flecks',
    price: 88,
    priceUnit: 'per sq ft',
    size: '18" x 18"',
    dimensions: '18" x 18"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1600566753151-384129cf4e3e?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600566753151-384129cf4e3e?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'granite-3',
    name: 'Absolute Black Granite',
    category: 'granite',
    description: 'Pure black granite, no veining',
    price: 105,
    priceUnit: 'per sq ft',
    size: '24" x 24"',
    dimensions: '24" x 24"',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=800&fit=crop',
    featured: false
  },

  // MOSAIC TILES
  {
    id: 'mosaic-1',
    name: 'Blue Glass Mosaic',
    category: 'mosaic',
    description: 'Stunning blue glass mosaic for accents',
    price: 85,
    priceUnit: 'per sq ft',
    size: '12" x 12" sheet',
    dimensions: '1" x 1" pieces',
    finish: 'Glossy',
    imageUrl: 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'mosaic-2',
    name: 'Hexagon Marble Mosaic',
    category: 'mosaic',
    description: 'White hexagon marble mosaic pattern',
    price: 92,
    priceUnit: 'per sq ft',
    size: '12" x 12" sheet',
    dimensions: '2" hexagons',
    finish: 'Polished',
    imageUrl: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'mosaic-3',
    name: 'Subway Mosaic Mix',
    category: 'mosaic',
    description: 'Mixed color mini subway mosaic',
    price: 78,
    priceUnit: 'per sq ft',
    size: '12" x 12" sheet',
    dimensions: '1" x 2" pieces',
    finish: 'Glossy',
    imageUrl: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&h=800&fit=crop',
    featured: false
  },

  // STONE-LOOK TILES
  {
    id: 'stone-1',
    name: 'Slate Look Tile',
    category: 'stone-look',
    description: 'Natural slate appearance with varied tones',
    price: 68,
    priceUnit: 'per sq ft',
    size: '12" x 24"',
    dimensions: '12" x 24"',
    finish: 'Textured',
    imageUrl: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'stone-2',
    name: 'Travertine Effect',
    category: 'stone-look',
    description: 'Classic travertine stone appearance',
    price: 72,
    priceUnit: 'per sq ft',
    size: '18" x 18"',
    dimensions: '18" x 18"',
    finish: 'Honed',
    imageUrl: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'stone-3',
    name: 'Limestone Look',
    category: 'stone-look',
    description: 'Soft limestone texture and color',
    price: 65,
    priceUnit: 'per sq ft',
    size: '12" x 24"',
    dimensions: '12" x 24"',
    finish: 'Matte',
    imageUrl: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=800&h=800&fit=crop',
    featured: false
  },

  // MODERN TILES
  {
    id: 'modern-1',
    name: 'Geometric Pattern Tile',
    category: 'modern',
    description: 'Bold geometric pattern for statement floors',
    price: 82,
    priceUnit: 'per sq ft',
    size: '8" x 8"',
    dimensions: '8" x 8"',
    finish: 'Matte',
    imageUrl: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&h=800&fit=crop',
    featured: true
  },
  {
    id: 'modern-2',
    name: 'Metallic Finish Tile',
    category: 'modern',
    description: 'Contemporary metallic finish for accents',
    price: 95,
    priceUnit: 'per sq ft',
    size: '12" x 12"',
    dimensions: '12" x 12"',
    finish: 'Metallic',
    imageUrl: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&h=800&fit=crop',
    featured: false
  },
  {
    id: 'modern-3',
    name: 'Large Format Neutral',
    category: 'modern',
    description: 'Minimalist large format tile in neutral tone',
    price: 75,
    priceUnit: 'per sq ft',
    size: '24" x 48"',
    dimensions: '24" x 48"',
    finish: 'Matte',
    imageUrl: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=400&fit=crop',
    textureUrl: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=800&fit=crop',
    featured: false
  }
];

export default tilesData;
